import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => ({
  path: "ecoursework/:yearGroupId/subjectview(/:componentId)",
  exact: true,
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "ecoursework" */ "./components"),
        import(
          /* webpackChunkName: "ecoursework" */ "IB_ECoursework/modules/ECourseworkModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "eCoursework",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
